<template>
  <div class="discover-tab-production-line-selector">
    <template v-if="programmers.length > 1">
      <span class="wt2-text-n2 -showing"
        >{{ 'dashboardFilter.showing' | culture }}:</span
      >

      <wt-google-like-loader v-if="_.isEmpty(programmers)" class="-default" />
      <template v-else>
        <wt-tags-list
          :tags="programmers"
          :selected-tags-ids="selectedProgrammerIds"
          :options="programmerTagsOptions"
          @removeTag="removeTag"
          :has-dropdown="false"
          ref="tagsList"
        />
        <wt-dropdown-view
          ref="dropdown"
          type="right"
          label="Filter"
          @opened="onOpened"
        >
          <template slot="label">
            <div class="wt2-color-link">{{ 'generic.EDIT' | culture }}</div>
          </template>
          <template slot="view" slot-scope="actions">
            <div class="-programmers-panel">
              <div class="wt2-text-m2 -title">
                {{ 'dashboardDiscover.selectProductionLines' | culture }}
              </div>
              <ul class="list-unstyled">
                <li>
                  <wt-check-box
                    :checked="dropdownStateAll"
                    :label-right="'dashboardFilter.filterAll' | culture"
                    @changed="onToggleAll"
                  />
                </li>
                <li v-for="p in dropdownState" :key="p.id">
                  <wt-check-box v-model="p.selected" :label-right="p.label" />
                </li>
              </ul>
              <footer>
                <wt-button
                  text="Cancel"
                  type="transparent"
                  @click="onCancel(actions.close)"
                />
                <wt-button text="Apply" @click="onApply(actions.close)" />
              </footer>
            </div>
          </template>
        </wt-dropdown-view>
      </template>
    </template>
  </div>
</template>

<script>
import app from 'app';

export default {
  name: 'discover-tab-production-line-selector',

  data: function () {
    return {
      programmerTagsOptions: {
        all: app.culture.dashboardDiscover.allProductionLines,
        none: app.culture.dashboardDiscover.allProductionLines,
      },
      dropdownState: [],
    };
  },

  computed: {
    selectedProgrammerIds() {
      return this.programmers.filter((p) => p.selected).map((p) => p.id);
    },

    dropdownStateAll() {
      return this.$_isAllSelected(this.dropdownState);
    },

    programmers() {
      return this.$store.state.dashboard.readyMadeProgrammers;
    },
  },

  methods: {
    onOpened() {
      app.Vue.set(this, 'dropdownState', _.cloneDeep(this.programmers));
      const allSelected = this.$_isAllSelected(this.dropdownState);
      if (allSelected) {
        _.each(this.dropdownState, (p) => {
          p.selected = false;
        });
      }
    },

    onToggleAll(value) {
      _.each(this.dropdownState, (p) => {
        p.selected = value;
      });
    },

    onApply(closeFunction) {
      closeFunction();

      const allSelected = this.$_isAllSelected(this.dropdownState);
      _.each(this.dropdownState, (pS) => {
        const p = _.find(this.programmers, (p) => p.id === pS.id);
        p.selected = allSelected || pS.selected;
      });

      this.$emit('on-change');
      this.dropdownState = [];
    },

    onCancel(closeFunction) {
      closeFunction();
      this.dropdownState = [];
    },

    removeTag(id) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && dropdown.isOpen) {
        this.onCancel(dropdown.close);
      }

      _.each(this.programmers, (p) => {
        if (p.id === id) {
          p.selected = false;
          return false; // break;
        }
      });

      const allSelected = this.$_isAllSelected(this.programmers);
      if (allSelected) {
        _.each(this.programmers, (p) => {
          p.selected = true;
        });
      }

      this.$emit('on-change');
    },

    $_isAllSelected(programmers) {
      return (
        _.every(programmers, (p) => !p.selected) ||
        _.every(programmers, (p) => p.selected)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.discover-tab-production-line-selector {
  display: flex;
  align-items: baseline;
  flex-shrink: 0;
  height: 50px;
  padding-left: 20px;

  .-showing {
    padding-right: 20px;
  }

  .wt-tags-list {
    width: auto;
    .text-instead-of-tags {
      align-items: center;
      display: flex;
      font-size: 15px;
      font-weight: 400;
    }
  }

  /deep/ .wt2-dropdown-view-component {
    .-toggle {
      width: 50px;
      //background-color: transparent;
    }
    .-programmers-panel {
      padding-left: 20px;
      max-height: 500px;
      overflow-y: auto;
      position: relative;
      li {
        height: 30px;
      }
    }
  }
}
</style>
